interface Props {
  hover?: boolean
  whiteTextColour?: boolean
  width?: string
  height?: string
}
const Action = ({
  hover,
  width = '24',
  height = '24',
  whiteTextColour,
}: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {hover && (
        <path
          d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z"
          fill={whiteTextColour ? 'White' : '#646464'}
        />
      )}
      {hover && (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.2932 11.25L12.8964 6.85335L13.6036 6.14624L18.8539 11.3965L19.2074 11.75L18.8538 12.1036L13.6035 17.3538L12.8965 16.6467L17.2932 12.25H5.5V11.25H17.2932Z"
          fill={whiteTextColour ? '#646464' : 'White'}
        />
      )}
      {!hover && (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM12.8964 6.85331L17.2932 11.25H5.5V12.25H17.2932L12.8965 16.6466L13.6035 17.3538L18.8538 12.1036L19.2074 11.75L18.8539 11.3964L13.6036 6.1462L12.8964 6.85331Z"
          fill={whiteTextColour ? 'White' : '#646464'}
        />
      )}
    </svg>
  )
}

export default Action
